/** venture/VicsPanel.tsx — 13단계 「VICS 투자실적 등록」 (조합 인수 전환사채 · 투자확인서 발급 전 선행, 2026-09-24)
 *  🔑 VICS ID·PW(3단계 값) → [1313] → [1319] → [1320] 법인별 입력 · [1329] 검증·확정은 조합 단위(VicsFundConfirm)에서 한 번. */
import React, { useState } from 'react';
import VicsStage from './VicsStage';
import VicsLogin from './VicsLogin';
import { VICS_CO_STAGES, vicsDone, vicsDoneCount } from './vics13';
import type { VicsStageKey } from './vics13';
import type { Project, CoCard } from './types';

interface Props { p: Project; co: CoCard; onPatch: (patch: Partial<Project>) => void; toast: (m: string) => void; }

export default function VicsPanel({ p, co, onPatch, toast }: Props) {
  const doneN = vicsDoneCount(p, co.id);
  const firstOpen = VICS_CO_STAGES.find((s) => !vicsDone(p, co.id, s.key));
  const [openKey, setOpenKey] = useState<VicsStageKey | ''>(firstOpen ? firstOpen.key : '');
  const [fold, setFold] = useState<boolean>(doneN === VICS_CO_STAGES.length);
  return (
    <div className={'vics' + (fold ? ' folded' : '')}>
      <div className="codoc-h" style={{ cursor: 'pointer' }} onClick={() => setFold(!fold)}>
        <span>🗂 VICS 투자실적 등록 <span className="s2tag">투자확인서 발급 전 선행</span></span>
        <span style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
          <span className={'pill ' + (doneN === VICS_CO_STAGES.length ? 'p-green' : doneN ? 'p-amber' : 'p-gray')}>{doneN}/{VICS_CO_STAGES.length} 화면 완료</span>
          <span className="s3muted">{fold ? '펼치기 ▾' : '접기 ▴'}</span>
        </span>
      </div>
      {fold ? null : (<>
        <VicsLogin p={p} toast={toast} />
        <div className="snote">로그인 후 VICS 메뉴에서 번호로 검색해 순서대로 입력합니다 · 각 화면의 값은 「복사」로 옮겨 적고, 첨부는 「보기·다운로드」로 꺼내 씁니다</div>
        {VICS_CO_STAGES.map((s) => (
          <VicsStage key={s.key} p={p} co={co} stage={s} open={openKey === s.key} onToggle={() => setOpenKey(openKey === s.key ? '' : s.key)} onPatch={onPatch} toast={toast} />
        ))}
        <div className="snote" style={{ marginTop: 6 }}>이 법인의 3화면이 끝나면 → 카드 아래 <b>조합 단위 [1329] 보고 검증·확정</b>에서 한 번 전송합니다 (법인마다 하지 않음)</div>
      </>)}
    </div>
  );
}
